import { GridColumnMenuFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import { ComponentType } from 'react';
import BarCodedIcon from 'src/assets/icons/BarCodedIcon';
import ContractedIcon from 'src/assets/icons/ContractedIcon';
import FormularyIcon from 'src/assets/icons/FormularyIcon';
import OfflineIcon from 'src/assets/icons/OfflineIcon';
import PictureAvailableIcon from 'src/assets/icons/PictureAvailableIcon';
import SpecialOrderIcon from 'src/assets/icons/SpecialOrderIcon';
import AttributeFilterUI, {
  AttributeFilterOption,
} from 'src/components/AttributeFilterUI';
import { extractAttributesFilter } from 'src/sections/shopping_lists/shoppingListProductMapper';
import { useContextSelector } from 'use-context-selector';
import { ShoppingListProductsContext } from '../ShoppingListProductsContext';

const shoppingListAttributeOptions: AttributeFilterOption[] = [
  {
    type: 'isContracted',
    label: 'Contracted Item',
    icon: <ContractedIcon />,
  },
  {
    type: 'isOfflineSupplierItem',
    label: 'Offline Supplier',
    icon: <OfflineIcon />,
  },
  {
    type: 'isSpecialOrder',
    label: (
      <span style={{ display: 'block', lineHeight: '1.3', whiteSpace: 'nowrap' }}>
        Special Order - Item may incur
        <br />
        additional shipping charges
      </span>
    ),
    icon: <SpecialOrderIcon />,
  },
  {
    type: 'isImageAvailable',
    label: 'Picture Available',
    icon: <PictureAvailableIcon />,
  },
  {
    type: 'isFormulary',
    label: 'Company Specified',
    icon: <FormularyIcon />,
  },
  {
    type: 'hasOldProductId',
    label: 'Item Replaced',
    icon: <BarCodedIcon />,
  },
];

const ShoppingListAttributesFilter: ComponentType<GridColumnMenuProps> = (columnMenuProps) => {
  const dataState = useContextSelector(ShoppingListProductsContext, (state) => state.dataState);
  const attributesFilter = extractAttributesFilter(dataState.filter);
  const persistedValue = attributesFilter?.attributes.join(',') ?? '';
  const persistedOperator = attributesFilter?.operator ?? 'or';

  return (
    <GridColumnMenuFilter
      {...columnMenuProps}
      expanded={true}
      hideSecondFilter
      filterUI={(filterUIProps) => (
        <AttributeFilterUI
          {...filterUIProps}
          firstFilterProps={{
            ...filterUIProps.firstFilterProps,
            value: persistedValue || filterUIProps.firstFilterProps.value,
            operator: persistedOperator || filterUIProps.firstFilterProps.operator,
          }}
          attributeOptions={shoppingListAttributeOptions}
        />
      )}
    />
  );
};

export default ShoppingListAttributesFilter;
